<template>
  <b-modal id="bpjs-ketenagakerjaan" ref="modal" size="lg" :title="title" @show="setData" @hidden="resetModal"
           @ok="handleOk" ok-title="Save">
    <b-form @submit.stop.prevent="onSubmit" ref="form">
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.registered_name)" v-model="input_data.registered_name" required ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.registered_number)" v-model="input_data.registered_number" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Date of Issue</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.issue_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.expiration_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mother Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.mother_name)" v-model="input_data.mother_name" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="description"
                      placeholder="Description"
                      rows="4"
                      v-model="input_data.desc"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.default"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Is Locked</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.is_locked"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Locked
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormTextarea,
  BModal
} from "bootstrap-vue"

import flatPickr from 'vue-flatpickr-component'
import vSelect from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "BpjsKetenagakerjaanInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BButton,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      title:"Add",
      input_data:{
        registered_name:"",
        registered_number:"",
        issue_date:"",
        expiration_date:"",
        mother_name:"",
        desc:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      },
      options:{
        basic_salaries:[],
        status:[{text:"Active", value:"active"}, { text:"Non Active", value:"non_active"}],
        default:[{text:"Yes", value:true}, { text:"No", value:"false"}],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    onSubmit(){
      let payload = {
        emp_id:this.$store.getters.empId,
        registered_number:this.input_data.registered_number,
        registered_name:this.input_data.registered_name,
        start_date:this.input_data.issue_date,
        end_date:this.input_data.expiration_date,
        nama_ibu:this.input_data.mother_name,
        desc:this.input_data.desc,
        status:(this.input_data.status == 'active'?1:0),
        user_id:this.$store.getters.userId
      }

      if (this.data !== null){
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.bpjs_ketenagakerjaan.update).then(res=>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.bpjs_ketenagakerjaan.add).then(res=>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }


    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.$parent.data = null
      this.title="Add"
      this.input_data={
        registered_name: "",
        registered_number: "",
        issue_date: "",
        expiration_date: "",
        mother_name: "",
        desc: "",
        status: "active",
        default: false,
        is_locked: "accepted"
      }
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.title= "Update"
          this. input_data={
            registered_name: this.data.name,
            registered_number: this.data.number,
            issue_date: this.data.valid_from,
            expiration_date: this.data.valid_until,
            mother_name: this.data.nama_ibu,
            desc: this.data.desc,
            status: (this.data.status == 1) ? 'active':'non_active',
            default: (this.data.is_default == 1) ? true:false,
            is_locked: "accepted"
          }
        }
      }, 100)
    }
  },
}
</script>